import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import classnames from 'classnames';
import isString from 'lodash/isString';

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong', 'u', 'br', 'em', 'a', 'div'],
  allowedAttributes: {
    strong: ['style'],
    a: ['href', 'class'],
    div: ['class', 'style']
  }
};

const ONE_LINE_LENGTH = 86; // in case of changes, please also update `max-width` in `.modal-frame-message`
const MAX_LINES_IN_SHORT_MESSAGE = 4;

type Props = {
  message?: string | React.ReactNode,
  children?: React.ReactNode,
  align?: 'center' | 'left',
  size?: 'normal' | 'h3',
  className?: string
};

class ModalFrameMessage extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'center',
    size: 'normal'
  };

  render() {
    const { children, message, align, size, className } = this.props;

    if (!message && !children) {
      return null;
    }

    let actualAlign = align;
    const messageLength = (isString(message) && message.length) || 0;

    if (messageLength > ONE_LINE_LENGTH * MAX_LINES_IN_SHORT_MESSAGE) {
      actualAlign = 'left';
    }

    const classes = classnames({
      'modal-frame-message': true,
      'modal-frame-message--multiline': messageLength > ONE_LINE_LENGTH,
      [`modal-frame-message--align-${String(actualAlign)}`]: actualAlign,
      [`modal-frame-message--size-${String(size)}`]: size,
      [`${String(className)}`]: Boolean(className),
      'text-overflow-wrap': true,
      'text-preserve-whitespaces': true
    });

    if (children) {
      // allow normal React children
      return (
        <div className={classes}>
          {children}
        </div>
      );
    }

    if (React.isValidElement(message)) {
      return (
        <div className={classes}>
          {message}
        </div>
      );
    }

    return (
      <div
        className={classes}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(message || '', SANITIZE_HTML_CONFIG) }}
      />
    );
  }
}

export default ModalFrameMessage;
